import { gql } from '@apollo/client';

export const UpdateConversationServices = gql`
mutation UpdateConversationServices($idStore: ID!, $content: contentConversation!) {
  updateConversationServices(idStore: $idStore, content: $content) {
    status
  }
}
`;